var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.schedule_rental)?_c('app-spinner'):[_c('app-schedule',{attrs:{"schedule":_vm.schedule_rental}})]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }